export default __webpack_public_path__ + "static/media/LebenswerkEcomServices.fb135b0b.svg";